import React from "react";

import {useSurveyResponses} from "../../../../api/SurveyAPI.js";
import ExportData from "../../../table/ExportData.js";

const SurveyResponses = ({ survey }) => {

    const [ responses ] = useSurveyResponses(survey.id);

    const headers = ['Nome', 'Email']
    survey.sections.forEach(section => section.questions.forEach(question => headers.push(question.question)))

    const data = responses.map(response => {
        const row = [response.User.name ,response.User.email];
        survey.sections.forEach(section => section.questions.forEach(question => row.push(response.answers[question.id])))
        return row;
    })

    return (
        <ExportData headers={headers} items={data} title="Respostas" filename="respostas.csv"/>
    )
}

export default SurveyResponses;